import React from 'react'
import { useGetInventoryVehicle } from '../../../../../api/dealership/inventory/useGetInventoryVehicle'
import { Outlet, Route, Routes } from 'react-router-dom'
import VehicleOverview from './VehicleOverview'
import { PageHeader, Pill } from '@demandlocal/components'
import { useParams } from 'react-router'
import { formatCurrency, formatNumber } from '../../../../../lib/utils/formatNumber'

const VehicleTemplate = (): JSX.Element => {
  const { vin } = useParams()
  const { data } = useGetInventoryVehicle(vin)

  return (
    <div className={'flex flex-1 flex-col'}>
      <PageHeader
        cardsOptions={[
          {
            title: 'Year',
            content: data?.year,
            color: 'bg-chrysler-blue/20',
          },
          {
            title: 'Mileage',
            content: formatNumber(Number(data?.mileage) || 0),
            color: 'bg-blue-aero/20',
          },
          {
            title: 'Current price',
            content: formatCurrency(Number(data?.price) || 0),
            color: 'bg-secondary-sunglow/20',
          },
        ]}
        title={`${data?.raw_make || ''} ${data?.raw_model || ''}`}
        backRoute={'../'}
      />
      <div className={'flex flex-1 flex-col px-10 max-w-[1920px] mx-auto w-full'}>
        <div className={'mt-12 mb-10'} />
        {data?.isMoved && (
          <span className={'self-center h-10 w-100'}>
            <Pill type="success">This vehicle has been moved!</Pill>
          </span>
        )}
        <Outlet />
      </div>
    </div>
  )
}

const Vehicle = (): JSX.Element => {
  return (
    <Routes>
      <Route element={<VehicleTemplate />}>
        <Route path={'/'} element={<VehicleOverview />} />
      </Route>
    </Routes>
  )
}

export default Vehicle
